import Select from "react-select";

const customStyles = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: (base: any) => ({
    ...base,
    minHeight: 30,
    border: "1px solid #b8bfca",
    boxShadow: "none",
    "&:hover, &:focus": {
      border: "1px solid #0071a1",
    },
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dropdownIndicator: (base: any) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearIndicator: (base: any) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SntSelect = (prop: any) => {
  const { styles = {} } = prop;

  return (
    <Select
      {...prop}
      styles={{ ...customStyles, ...styles }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};

export default SntSelect;
